module.exports = __webpack_public_path__ + "static/Q4Answer_reveal4_wishmastree-b4c8dcfe88c4974e5c7501aa380ddd4c.jpg";